import type { AppSession } from './session-types';

export type AuthSessionProbe = {
  data: AppSession | null;
  isPending: boolean;
  error: { message?: string } | null;
  refetch: () => Promise<unknown>;
};

/**
 * Prefer a live better-auth session; otherwise bridge with a cached profile so
 * brief offline/reconnect gaps (Wi‑Fi changes, flaky get-session) do not bounce
 * to login while the cache TTL is still valid.
 */
export function resolveAuthSession(
  probe: AuthSessionProbe,
  cachedUser: AppSession['user'] | null,
): AuthSessionProbe {
  if (probe.data?.user) {
    return probe;
  }

  if (cachedUser) {
    return {
      data: { user: cachedUser },
      isPending: false,
      error: null,
      refetch: probe.refetch,
    };
  }

  return probe;
}
